import i from './checkout.container';

export default i;
